export const UNIT_OPTIONS = [
  {
    id: null,
    name: 'Chọn đơn vị tính',
  },
  {
    id: 1,
    name: 'Cái',
  },
  {
    id: 2,
    name: 'Bộ',
  },
  {
    id: 3,
    name: 'Gói',
  },
];

export const PRODUCT_HEADER_FIELDS = [
  {
    key: 'count',
    label: 'STT',
    sortable: false,
    thStyle: { textAlign: 'center' },
  },
  {
    key: 'barCode',
    label: 'Mã vạch',
    sortable: false,
    thStyle: { textAlign: 'center' },
  },
  {
    key: 'productCode',
    label: 'Mã sản phẩm',
    sortable: false,
    thStyle: { textAlign: 'center' },
  },
  {
    key: 'productName',
    label: 'Tên sản phẩm',
    sortable: false,
    thStyle: { textAlign: 'center' },
  },
  {
    key: 'originalPrice',
    label: 'Giá nhập',
    sortable: false,
    thStyle: { textAlign: 'center' },
  },
  {
    key: 'sellingPrice',
    label: 'Giá bán',
    sortable: false,
    thStyle: { textAlign: 'center' },
  },
  {
    key: 'status',
    label: 'Trạng thái',
    sortable: false,
    thStyle: { textAlign: 'center' },
  },
  { key: 'actions', label: '' },
];

export const COMBO_HEADER_FIELDS = [
  {
    key: 'productCode',
    label: 'Mã sản phẩm',
    sortable: false,
    thStyle: { textAlign: 'center', width: '20%' },
  },
  {
    key: 'productName',
    label: 'Tên sản phẩm',
    sortable: false,
    thStyle: { textAlign: 'center', width: '30%' },
  },
  {
    key: 'quantity',
    label: 'Số lượng',
    sortable: false,
    thStyle: { textAlign: 'center', width: '14%' },
  },
  {
    key: 'productComboPrice',
    label: 'Giá tiền combo',
    sortable: false,
    thStyle: { textAlign: 'center', width: '14%' },
  },
  {
    key: 'productComboRate',
    label: 'Tỷ lệ phân bổ ',
    sortable: false,
    thStyle: { textAlign: 'center', width: '14%' },
  },
  {
    key: 'actions',
    label: '',
    thStyle: { textAlign: 'center', width: '14%' },
  },
];

export const PRODUCT_STATUS_OPTIONS = [
  { id: 1, name: 'Đang bán' },
  { id: 2, name: 'Ngừng bán' },
];

export const PRODUCT_TYPE_OPTIONS = [
  { id: 1, name: 'Sản phẩm' },
  { id: 2, name: 'Sản phẩm theo IMEI' },
  // { id: 3, name: 'Combo' },
  { id: 4, name: 'Sản phẩm dịch vụ' },
];
